/* search-dialog.js — the header search surface (snippets/search-dialog.liquid,
 * design boards SearchEmpty / SearchOpen; client meeting 2026-08-26).
 *
 * TWO MODES share the one header input (Luke: the catalogue live search we
 * built AND the TheBlueSpace-style dialog):
 *
 *   grid        collection / search pages carrying the Typesense island
 *               ([data-ts-plp]). The input keeps filtering the grid in place
 *               exactly as before — usearch.js + typesense-plp.js own it, this
 *               file only wires the scope button fused to the bar's right end
 *               (icon · "in <collection>" · chevron → a two-item radio menu:
 *               This collection / Everywhere) and steps aside.
 *   everywhere  every other page, and a grid page once the shopper picks
 *               "Everywhere". Focus with nothing typed opens the EMPTY state
 *               (explore · top products · recently viewed · guides · brands);
 *               typing opens the TYPED state (completions · products ·
 *               collections rail · guides). Enter with no result focused
 *               submits the form to /search (the full live catalogue grid).
 *
 * DATA. One federated multi_search per keystroke (typesense app
 * docs/SEARCH-DIALOG.md, PR #29): products (8 + top-3 `collections` facet),
 * content (3), product_queries (9). The cluster does not carry the last two
 * until #29 is deployed and the search key re-minted, so every index-fed block
 * is presence-gated on its search answering with hits, and a search that
 * errors is dropped from later requests on this page (dead[]). Products come
 * from the same window.TYPESENSE config the PLP island uses — no second key.
 * Explore chips and the collections rail's titles are read off the hub bands
 * the header already rendered (the compiled menu) — no second data path.
 *
 * KEYBOARD. ArrowDown from the input enters the results; arrows walk them
 * (Up from the first returns to the input); Enter follows the focused link;
 * Escape closes and returns focus to the input; a printable key while a
 * result is focused goes back to the input. aria-expanded / aria-controls on
 * the input, role=dialog on the surface.
 */
/* Brand visibility (Ranya Sarkis via Luke, 2026-09-16): a hit whose
   product_type is in window.ST_BRAND_HIDDEN_TYPES (the list Liquid reads in
   snippets/brand-hidden.liquid) shows no vendor, and its title is shown
   without a leading vendor name. Display only. */
/* 2026-09-23: delegates to window.STBrand (layout/theme.liquid) — blackout
   vendor list, tile-category tags, the index's brand_hidden flag, and a
   blackout name anywhere in the title (docs/decisions/2026-09-23-tile-brand-blackout.md). */
function brandHidden(d) { if (window.STBrand) return window.STBrand.hidden(d); var L = Array.isArray(window.ST_BRAND_HIDDEN_TYPES) ? window.ST_BRAND_HIDDEN_TYPES : []; return !!(d && d.product_type && L.indexOf(d.product_type) !== -1); }
function titleShown(d) { var t = (d && d.title) || ''; if (window.STBrand) return window.STBrand.title(d, t); if (!brandHidden(d) || !d.vendor) return t; var lead = d.vendor + ' '; return t.indexOf(lead) === 0 ? t.slice(lead.length).replace(/^\s+/, '') : t; }
(function () {
  'use strict';
  var header = document.querySelector('.site-header--tabbed');
  if (!header) return;
  var bar = header.querySelector('[data-usearch][data-usearch-dialog]');
  var dialog = header.querySelector('[data-search-dialog]');
  if (!bar || !dialog) return;

  var C = window.TYPESENSE || null;
  var live = !!(C && C.apiKey && C.host && window.fetch);
  var gridPage = !!document.querySelector('[data-ts-plp]');
  var scopeRoot = bar.querySelector('[data-search-scope]');
  var scope = gridPage ? 'grid' : 'everywhere';
  var open = false;
  var query = '';
  var seq = 0;
  var timer = null;
  var dead = {};          // collection name -> true once it errored on this page
  var cache = {};         // query -> parsed multi_search response
  var cacheKeys = [];
  var CACHE_MAX = 40;
  /* MEASURED 2026-09-21 (perf/search-as-you-type): at a 120ms typing cadence
   * 140 already meant no request left until the shopper paused — the tax the
   * dialog charges is not the query, it is everything that happens AFTER it
   * settles (see startPipeline). 220 matches TYPE_DEBOUNCE in
   * assets/typesense-plp.js so the two surfaces never disagree about when a
   * query is "finished". */
  var DEBOUNCE = 220;
  var emptyBuilt = false;
  var titleMap = null;
  var hubHandles = null;  // tier-1 hub collections: the band itself, never a rail card
  var pointerInside = false;
  var closedAt = 0;       // close() stamps this; a focusin inside 250ms is the refocus, not intent

  var $ = function (sel, root) { return (root || dialog).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || dialog).querySelectorAll(sel)); };
  var emptyState = $('[data-sd-empty]');
  var typedState = $('[data-sd-typed]');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    if (n == null || isNaN(Number(n))) return '';
    try { return Number(n).toLocaleString('en-AU', { style: 'currency', currency: (C && C.currency) || 'AUD' }); }
    catch (e) { return '$' + n; }
  }
  // Shopify CDN rendition: ask for a 320px file, never the original
  function sized(u, w) {
    if (!u || u.indexOf('cdn.shopify.com') < 0) return u || '';
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function humanise(handle) {
    return String(handle || '').replace(/[-_]+/g, ' ').replace(/^\w/, function (c) { return c.toUpperCase(); });
  }

  /* ---------- the input (the island swaps its own into the slot) -------- */
  function activeInput() {
    var slotInput = bar.querySelector('[data-usearch-slot]:not([hidden]) input');
    return slotInput || bar.querySelector('[data-usearch-input]');
  }
  function inputValue() { var i = activeInput(); return i ? i.value.trim() : ''; }

  /* ---------- open / close ---------------------------------------------- */
  function setAria(expanded) {
    var i = activeInput();
    if (!i) return;
    i.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    i.setAttribute('aria-controls', dialog.id);
    i.setAttribute('aria-haspopup', 'dialog');
  }
  function place() {
    // the dialog is absolutely positioned under the bar; cap its height to
    // what is left of the viewport so it scrolls inside itself, never the page
    var b = bar.closest('.site-header__bar') || bar;
    var top = Math.max(0, Math.round(b.getBoundingClientRect().bottom));
    dialog.style.setProperty('--sd-top', top + 'px');
  }
  function show() {
    if (open) return;
    open = true;
    place();
    dialog.hidden = false;
    bar.classList.add('is-dialog-open');
    header.classList.add('is-search-open');     // theme.js: never hide the header under it
    setAria(true);
    render();
    warmNext();   // image warming paused while closed resumes
    if (run.paused) { var r = run.paused; run.paused = null; nextPage(r); }
  }
  function close(refocus) {
    if (!open) return;
    open = false;
    dialog.hidden = true;
    bar.classList.remove('is-dialog-open');
    header.classList.remove('is-search-open');
    setAria(false);
    closedAt = Date.now();
    if (refocus) { var i = activeInput(); if (i) i.focus(); }
  }

  /* ---------- scope button + menu (grid pages only) --------------------- */
  // sections/header.liquid renders the control (server side, first frame);
  // this owns the menu (role=menu, two menuitemradio), the label swap, the
  // placeholder and the mode switch. The choice is NOT remembered across
  // pages: every grid page opens scoped to itself. It used to be kept in
  // sessionStorage for the tab, which made every later collection page
  // flash "in <collection>" (SSR) and then flip to Everywhere (Luke,
  // 2026-09-17: "when I click a megamenu menu item ... search switches to
  // searching through that megamenu collection ... right now it's briefly
  // showing selected to search within that category and then flipping back
  // to global search with a quick render flash"). The first collection page
  // of a session pulses the button once (is-hint, CSS).
  var scopeBtn = scopeRoot ? scopeRoot.querySelector('[data-search-scope-btn]') : null;
  var scopeMenu = scopeRoot ? scopeRoot.querySelector('[data-search-scope-menu]') : null;
  var scopeText = scopeRoot ? scopeRoot.querySelector('[data-search-scope-text]') : null;
  var scopeTitle = scopeRoot ? (scopeRoot.getAttribute('data-scope-title') || '') : '';
  var scopeKind = scopeRoot ? scopeRoot.getAttribute('data-scope-kind') : '';
  var HINT_KEY = 'st.scopeHint';
  var plainInput = bar.querySelector('[data-usearch-input]');
  var placeholderAll = (plainInput && plainInput.getAttribute('placeholder')) || 'Search products, brands and finishes';
  var placeholderGrid = scopeKind === 'collection' ? 'Search within ' + scopeTitle + '\u2026' : 'Search products\u2026';
  var menuOpen = false;

  function scopeItems() { return scopeMenu ? $$('[data-search-mode]', scopeMenu) : []; }
  function syncPlaceholder() {
    if (!scopeRoot) return;
    var i = activeInput();
    var want = scope === 'everywhere' ? placeholderAll : placeholderGrid;
    if (i && i.placeholder !== want) i.placeholder = want;
  }
  function paintScope() {
    if (!scopeRoot) return;
    var everywhere = scope === 'everywhere';
    scopeRoot.classList.toggle('uscope--everywhere', everywhere);
    scopeItems().forEach(function (b) {
      b.setAttribute('aria-checked', b.getAttribute('data-search-mode') === scope ? 'true' : 'false');
    });
    var label = everywhere ? 'Everywhere' : 'in ' + scopeTitle;
    if (scopeText) scopeText.textContent = label;
    if (scopeBtn) scopeBtn.setAttribute('aria-label', 'Search scope: ' + label + '. Change');
    syncPlaceholder();
  }
  function setScope(next) {
    scope = next;
    paintScope();
    var i = activeInput();
    if (next === 'grid') { close(true); if (i) i.focus(); }
    else { if (i) i.focus(); show(); }
  }
  function openMenu(focusIdx) {
    if (!scopeMenu || menuOpen) return;
    menuOpen = true;
    scopeMenu.hidden = false;
    scopeBtn.setAttribute('aria-expanded', 'true');
    var items = scopeItems();
    var idx = focusIdx;
    if (idx == null) { idx = 0; items.forEach(function (b, k) { if (b.getAttribute('aria-checked') === 'true') idx = k; }); }
    if (idx < 0) idx = items.length - 1;
    if (items[idx]) items[idx].focus();
  }
  function closeMenu(refocus) {
    if (!scopeMenu || !menuOpen) return;
    menuOpen = false;
    scopeMenu.hidden = true;
    scopeBtn.setAttribute('aria-expanded', 'false');
    if (refocus) scopeBtn.focus();
  }
  if (scopeRoot && scopeBtn && scopeMenu) {
    scopeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (menuOpen) closeMenu(true); else openMenu(null);
    });
    scopeBtn.addEventListener('keydown', function (e) {
      // Enter / Space are the button's own click; arrows open onto an end
      if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); openMenu(0); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); openMenu(-1); }
    });
    scopeMenu.addEventListener('keydown', function (e) {
      var items = scopeItems();
      var idx = items.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeMenu(true); return; }
      if (e.key === 'Tab') { closeMenu(false); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); items[(idx + 1) % items.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); items[(idx - 1 + items.length) % items.length].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); e.stopPropagation(); items[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); e.stopPropagation(); items[items.length - 1].focus(); }
      else if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) e.stopPropagation(); // usearch.js type-anywhere stays out
    });
    scopeMenu.addEventListener('click', function (e) {
      var b = e.target.closest('[data-search-mode]');
      if (!b) return;
      e.preventDefault();
      closeMenu(false);
      setScope(b.getAttribute('data-search-mode'));
    });
    document.addEventListener('pointerdown', function (e) { if (menuOpen && !scopeRoot.contains(e.target)) closeMenu(false); });
    document.addEventListener('focusin', function (e) { if (menuOpen && !scopeRoot.contains(e.target)) closeMenu(false); });

    // the key older builds wrote; clear it so nothing else can read it back
    try { sessionStorage.removeItem('st.searchScope'); } catch (e) { /* no storage */ }
    paintScope();
    // the island swaps its own input into the slot after boot and writes its
    // own "Search within …" placeholder; keep it in step with the scope
    if (window.MutationObserver) {
      new MutationObserver(syncPlaceholder).observe(bar, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'placeholder'] });
    }
    var hinted = null;
    try { hinted = sessionStorage.getItem(HINT_KEY); } catch (e) { hinted = null; }
    if (scopeKind === 'collection' && !hinted) {
      try { sessionStorage.setItem(HINT_KEY, '1'); } catch (e) { /* no storage: still hint this once */ }
      var endHint = function () { scopeRoot.classList.remove('is-hint'); };
      scopeRoot.classList.add('is-hint');
      scopeBtn.addEventListener('animationend', endHint, { once: true });
      setTimeout(endHint, 1600);
    }
  }

  /* ---------- state: empty vs typed ------------------------------------- */
  function render() {
    query = inputValue();
    if (!query) {
      // clearing the field ends the query: the seq/query guards already stop
      // the prefetch run PAINTING, but without this its pages keep arriving
      seq += 1;
      clearTimeout(settleTimer);
      newFlight();
      spinning(false);
      typedState.hidden = true;
      emptyState.hidden = false;
      buildEmpty();
      return;
    }
    if (!live) { close(false); return; }     // no index: the form submit is the search
    emptyState.hidden = true;
    typedState.hidden = false;
    search(query);
  }

  /* ---------- EMPTY state ----------------------------------------------- */
  function buildEmpty() {
    if (emptyBuilt) return;
    emptyBuilt = true;
    // explore: the tier-2 category links of every hub band, in menu order —
    // the compiled menu the header rendered, so staff reorder it in the app
    var n = Number(dialog.getAttribute('data-sd-explore')) || 8;
    var seen = {};
    var chips = [];
    $$('.hubnav__band .hubnav__cat:not(.hubnav__cat--cta) > .hubnav__cat-link', header).forEach(function (a) {
      var href = a.getAttribute('href');
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!href || href === '#' || !label || /^Browse\b/.test(label) || seen[href]) return;
      seen[href] = 1;
      chips.push({ href: href, label: label });
    });
    var exploreSec = $('[data-sd-explore]');
    if (chips.length) {
      $('[data-sd-explore-list]').innerHTML = chips.slice(0, n).map(function (c) {
        return '<a class="sdialog__chip" href="' + esc(c.href) + '" data-sd-item>' + esc(c.label) + '</a>';
      }).join('');
      exploreSec.hidden = false;
    }
    /* recently viewed: ui.js writes st_recent on every PDP visit.
     *
     * TWO SHAPES live in that key since 2026-09-21. v2 entries are full card
     * documents (snippets/card-json.liquid) whose `price` is a NUMBER in
     * dollars, because window.STCard.render() formats it; pre-2026-09-21
     * entries carry a pre-formatted money STRING. Both are rendered here, so
     * the overlay's idle strip survives the migration in either direction.
     *
     * This strip stays the compact .sd-tile and is NOT the rail card: it is a
     * four-up navigation affordance inside a narrow overlay panel, with no
     * room for a quick view button, an image pager or a swatch strip. The
     * product results BELOW it, in the typed state, are the catalogue card
     * (window.STCard.render, further down this file). */
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('st_recent') || '[]'); } catch (e) { recent = []; }
    var here = document.querySelector('[data-rv-product]');
    var hereHandle = here ? here.getAttribute('data-handle') : null;
    var recentUrl = function (x) { return x.url || (x.handle ? '/products/' + x.handle : ''); };
    var recentPrice = function (x) {
      if (x.availability === 'call_for_price') return 'Call for price';
      if (x.price == null || x.price === '') return '';
      if (typeof x.price === 'number') return window.STCard ? window.STCard.money(x.price) : '$' + x.price;
      return x.price;   // legacy entry: already a money string
    };
    /* v2 stores the image with NO width, because window.STCard.cdn() appends
     * its own and a URL carrying two is an ambiguous request. `sized()` above
     * only ever fired on cdn.shopify.com originals and would leave a Liquid
     * URL (//<shop>/cdn/shop/…) at FULL SIZE in a 320px tile, so the dialog
     * asks STCard for the rendition instead. Legacy entries already carry
     * ?width=600 and are left exactly as they are. */
    var recentImg = function (u) {
      if (!u) return '';
      if (/[?&]width=/.test(u)) return u;
      return window.STCard ? window.STCard.cdn(u, 320) : sized(u, 320);
    };
    recent = recent.filter(function (x) { return x && recentUrl(x) && x.handle !== hereHandle; }).slice(0, 4);
    if (recent.length) {
      $('[data-sd-recent-list]').innerHTML = recent.map(function (x) {
        var money = recentPrice(x);
        return '<a class="sd-tile" href="' + esc(recentUrl(x)) + '" data-sd-item>' +
          '<span class="sd-tile__media">' + (x.image && /^(https?:)?\/\//.test(x.image) ? '<img src="' + esc(recentImg(x.image)) + '" alt="" width="320" height="320" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="sd-tile__title">' + esc(x.title) + '</span>' +
          (money ? '<span class="sd-tile__price">' + esc(money) + '</span>' : '') + '</a>';
      }).join('');
      $('[data-sd-recent]').hidden = false;
    }
    if (!live) return;
    // index-fed fallbacks: bestsellers when no collection is set; live content
    // rows over the staff menu when the content index answers
    var searches = [];
    var wantTop = dialog.getAttribute('data-sd-top-ssr') !== '1';
    if (wantTop) searches.push({
      collection: C.collection || 'products', q: '*', query_by: 'title', per_page: 5, filter_by: availFilter,
      include_fields: 'id,title,handle,vendor,product_type,price,compare_at_price,image,available,availability,best_selling_rank',
      sort_by: 'best_selling_rank:asc',
    });
    if (C.content && !dead[C.content]) searches.push({
      collection: C.content, q: '*', query_by: 'title', filter_by: 'published:=true', per_page: 4,
      include_fields: 'id,title,handle,url,type,excerpt', sort_by: 'priority:desc,updated_at:desc',
    });
    if (!searches.length) return;
    post({ searches: searches }).then(function (res) {
      var results = (res && res.results) || [];
      var i = 0;
      if (wantTop) {
        var top = results[i++];
        if (top && top.hits && top.hits.length) {
          $('[data-sd-top-list]').innerHTML = top.hits.map(function (h, k) { return tile(h.document, k === 0); }).join('');
          $('[data-sd-top]').hidden = false;
        }
      }
      if (C.content && !dead[C.content]) {
        var content = results[i++];
        if (content && content.hits && content.hits.length) {
          $('[data-sd-guides-list]').innerHTML = content.hits.map(function (h) { return row(h.document); }).join('');
          $('[data-sd-guides]').hidden = false;
        } else if (content && content.error) dead[C.content] = true;
      }
    }, function () { /* offline: the SSR blocks stand */ });
  }

  /* ---------- TYPED state ----------------------------------------------- */
  // Luke, 2026-09-17: "get rid of the 'In stock' tag on search results" — it
  // was on nearly every tile (the index only carries sellable stock), so it
  // said nothing. In-store only and Best seller stay: they change a decision.
  function badge(d) {
    if (d.availability === 'in_store_only') return 'In-store only';
    if (d.best_selling_rank != null && d.best_selling_rank > 0 && d.best_selling_rank <= 50) return 'Best seller';
    return '';
  }
  function tile(d, forceBest) {
    var b = forceBest ? 'Best seller' : badge(d);
    // $1.00 saving floor (window.STBadges.isSaving): under it is rounding, not a sale
    var B = window.STBadges;
    var sale = d.compare_at_price != null && d.price != null && !!(B && B.isSaving && B.isSaving(d.price, d.compare_at_price));
    return '<a class="sd-tile" href="/products/' + esc(d.handle) + '" data-sd-item>' +
      '<span class="sd-tile__media">' + (b ? '<span class="sd-tile__badge">' + b + '</span>' : '') +
      (d.image ? '<img src="' + esc(sized(d.image, 320)) + '" alt="" width="320" height="320" loading="lazy" decoding="async">' : '') + '</span>' +
      (d.vendor && !brandHidden(d) ? '<span class="sd-tile__vendor">' + esc(d.vendor) + '</span>' : '') +
      '<span class="sd-tile__title">' + esc(titleShown(d)) + '</span>' +
      (d.availability === 'call_for_price' ? '<span class="sd-tile__price sd-tile__price--cfp">Call for price</span>'
        : d.price != null ? '<span class="sd-tile__price">' + money(d.price) + (sale ? '<s>' + money(d.compare_at_price) + '</s>' : '') + '</span>' : '') +
      '</a>';
  }
  /* Products in the typed state are THE catalogue card (window.STCard,
   * assets/product-card.js) inside the PLP's own list item, so quick view,
   * add to cart, save to list, badges, swatches, the hover carousel and the
   * media loadbar all come from the same code the collection grid runs
   * (Luke, 2026-09-17: "identical in every way, just in search results").
   * tile() below stays for the EMPTY state's top-products strip. */
  function cardHTML(d, position) {
    if (!window.STCard) return tile(d, false);
    return '<li class="plp-hit ais-Hits-item">' + window.STCard.render(d, position) + '</li>';
  }
  function row(d) {
    return '<a class="sdialog__row" href="' + esc(d.url || ('/pages/' + d.handle)) + '" data-sd-item><span>' + esc(titleShown(d)) + '</span>' +
      (d.type ? '<span class="sdialog__n">' + esc(d.type) + '</span>' : '') + '</a>';
  }
  function completion(q, typed) {
    // bold the typed prefix ourselves rather than trusting index highlights
    // into innerHTML
    var i = q.toLowerCase().indexOf(typed.toLowerCase());
    if (i < 0) return esc(q);
    return esc(q.slice(0, i)) + '<b>' + esc(q.slice(i, i + typed.length)) + '</b>' + esc(q.slice(i + typed.length));
  }
  function handleOf(href) {
    var m = (href || '').match(/\/collections\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function hubs() {
    if (hubHandles) return hubHandles;
    hubHandles = {};
    $$('.hubnav__tab[href]', header).forEach(function (a) { var h = handleOf(a.getAttribute('href')); if (h) hubHandles[h] = 1; });
    return hubHandles;
  }
  // rail candidates: the facet's handles minus the hub the band already is,
  // minus the app's hidden utility collections (best-selling-source) and the
  // catch-alls; the first three left, in facet (count) order
  function railHandles(counts) {
    var skip = hubs();
    return counts.filter(function (c) {
      var h = c.value;
      return h && c.count > 0 && !skip[h] && !/-source$/.test(h) && h !== 'all' && h !== 'frontpage';
    }).slice(0, 3);
  }
  function titles() {
    if (titleMap) return titleMap;
    titleMap = {};
    $$('.hubnav a[href*="/collections/"]', header).forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      if (!m || titleMap[m[1]]) return;
      var label = a.querySelector('span') ? a.querySelector('span').textContent : a.textContent;
      label = (label || '').replace(/\s+/g, ' ').replace(/\s*→\s*$/, '').replace(/^Shop all\s+/i, '').trim();
      if (label) titleMap[m[1]] = label.charAt(0).toUpperCase() + label.slice(1);
    });
    return titleMap;
  }

  // configurator components stay out of results (availability:!=component);
  // gated on the theme setting until the index carries the field, because an
  // unknown filter field errors the whole multi_search.
  var availFilter = C && C.availabilityFilter ? 'availability:!=component' : undefined;
  /* 50 per page, EVERY page (Luke, 2026-09-17: "aggressively prefetch in
   * batches of 50 and also continue until all possible search results have
   * been prefetched"). One size for page 1 and the rest, because Typesense
   * pages by per_page: an 8-hit first page followed by 50-hit pages would
   * skip hits 9-50. include_fields carries everything the catalogue card
   * renders (assets/product-card.js). */
  var PER_PAGE = 50;
  var CARD_FIELDS = 'id,objectID,title,handle,vendor,product_type,price,compare_at_price,image,images,available,availability,best_selling_rank,tags,finishes,finish_images,colours,rating,rating_count,created,badges';
  function productsSearch(q, sortFallback, page) {
    return {
      collection: C.collection || 'products', q: q,
      query_by: 'title,vendor,skus,product_type,tags', query_by_weights: '6,4,5,3,2',
      filter_by: availFilter,
      per_page: PER_PAGE, page: page || 1, include_fields: CARD_FIELDS,
      facet_by: 'collections', max_facet_values: 12, highlight_full_fields: 'none', typo_tokens_threshold: 1,
      sort_by: sortFallback ? '_text_match:desc' : '_text_match:desc,best_selling_rank:asc',
    };
  }
  function federated(q) {
    var s = [productsSearch(q, false)];
    var plan = ['products'];
    if (C.content && !dead[C.content]) {
      s.push({ collection: C.content, q: q, query_by: 'title,excerpt,tags,body', query_by_weights: '8,4,3,1',
        filter_by: 'published:=true', per_page: 3, include_fields: 'id,title,handle,url,type,excerpt',
        highlight_full_fields: 'none', sort_by: '_text_match:desc,priority:desc' });
      plan.push('content');
    }
    if (C.suggestions && !dead[C.suggestions]) {
      s.push({ collection: C.suggestions, q: q, query_by: 'q', per_page: 9, highlight_full_fields: 'none',
        num_typos: 0, prefix: true, sort_by: '_text_match:desc,count:desc' });
      plan.push('suggestions');
    }
    return { body: { searches: s }, plan: plan };
  }
  /* Every request this file makes belongs to ONE query. `inflight` is that
   * query's AbortController: the next query aborts it, so a superseded
   * federated search and — far more expensive — a superseded page of the
   * prefetch pipeline stop arriving instead of being downloaded, parsed and
   * then dropped by the seq guard. Before this, typing on through a 7-page
   * run kept every one of those 50-hit, ~75KB pages coming (MEASURED
   * 2026-09-21: one settled query for "timberline vanity" pulled 7 pages =
   * 464KB and built 311 cards into the dropdown). The seq/query guards stay
   * exactly as they were — abort is the network half, they are the paint
   * half, and a browser that rejects `signal` still behaves correctly. */
  var inflight = null;
  function newFlight() {
    if (inflight) { try { inflight.abort(); } catch (e) { /* older browser */ } }
    inflight = (typeof AbortController === 'function') ? new AbortController() : null;
    return inflight;
  }
  function aborted(e) { return !!(e && (e.name === 'AbortError' || /abort/i.test(e.message || ''))); }
  function post(body, ctrl) {
    var url = C.protocol + '://' + C.host + ':' + (C.port || 443) + '/multi_search?x-typesense-api-key=' + encodeURIComponent(C.apiKey);
    var init = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) };
    if (ctrl && ctrl.signal) init.signal = ctrl.signal;
    return fetch(url, init)
      .then(function (r) { if (!r.ok) throw new Error('typesense ' + r.status); return r.json(); });
  }
  function remember(q, res) {
    if (cache[q]) return;
    cache[q] = res; cacheKeys.push(q);
    while (cacheKeys.length > CACHE_MAX) delete cache[cacheKeys.shift()];
  }

  function search(q) {
    var my = ++seq;
    // the flight opens BEFORE the cache check: a cached answer still means the
    // previous query is over, and its prefetch pages must stop arriving
    var ctrl = newFlight();
    if (cache[q]) { paint(q, cache[q]); return; }
    dialog.setAttribute('aria-busy', 'true');
    var f = federated(q);
    post(f.body, ctrl).then(function (res) {
      var results = (res && res.results) || [];
      var byPlan = {};
      f.plan.forEach(function (name, i) { byPlan[name] = results[i] || null; });
      // a products sort on the optional rank field is the one thing here that
      // can 400 on an older index: retry once on relevance alone
      if (byPlan.products && byPlan.products.error) {
        return post({ searches: [productsSearch(q, true)] }, ctrl).then(function (r2) {
          byPlan.products = (r2 && r2.results && r2.results[0]) || null;
          return byPlan;
        });
      }
      return byPlan;
    }).then(function (byPlan) {
      if (byPlan.content && byPlan.content.error) dead[C.content] = true;
      if (byPlan.suggestions && byPlan.suggestions.error) dead[C.suggestions] = true;
      remember(q, byPlan);
      if (my !== seq) return;
      paint(q, byPlan);
    }, function (e) {
      if (aborted(e) || my !== seq) return;   // superseded: the next query owns the UI
      dialog.removeAttribute('aria-busy');
      $('[data-sd-offline]').hidden = false;
      $('[data-sd-none]').hidden = true;
    });
  }

  function paint(q, byPlan) {
    dialog.removeAttribute('aria-busy');
    var offline = $('[data-sd-offline]'); offline.hidden = true;
    var p = byPlan.products;
    var list = $('[data-sd-products-list]');
    var none = $('[data-sd-none]');
    var all = $('[data-sd-all]');
    var count = $('[data-sd-count]');
    var hits = (p && p.hits) || [];
    if (p && p.error) { list.innerHTML = ''; none.hidden = true; offline.hidden = false; }
    else if (!hits.length) {
      list.innerHTML = '';
      $('[data-sd-none-q]').textContent = '“' + q + '”';
      none.hidden = false;
    } else {
      list.innerHTML = hits.map(function (h, i) { return cardHTML(h.document, i + 1); }).join('');
      none.hidden = true;
    }
    var found = p && !p.error ? (p.found || 0) : 0;
    count.textContent = found ? String(found) : '';
    all.hidden = !found;
    all.textContent = 'See all ' + (found ? found + ' results' : 'results') + ' →';
    all.href = '/search?q=' + encodeURIComponent(q);
    startPipeline(q, hits.length, found);

    // completions
    var sugs = $('[data-sd-sugs]');
    var sh = (byPlan.suggestions && byPlan.suggestions.hits) || [];
    sh = sh.filter(function (h) { return h.document && h.document.q && h.document.q.toLowerCase() !== q.toLowerCase(); });
    // Brand blackout (2026-09-23): the suggestions collection is built from
    // what shoppers TYPED, and a supplier's own code pasted into the box
    // ("stoneworldrichmondburnley200x200...") would otherwise be offered to the
    // next shopper. Glued forms are caught too (STBrand.inside).
    if (window.STBrand) sh = sh.filter(function (h) { return !window.STBrand.inside(h.document.q); });
    if (sh.length) {
      sugs.innerHTML = sh.map(function (h) {
        return '<button class="sdialog__sug" type="button" data-sd-item data-sd-sug="' + esc(h.document.q) + '">' + completion(h.document.q, q) + '</button>';
      }).join('');
      sugs.hidden = false;
    } else { sugs.innerHTML = ''; sugs.hidden = true; }

    // collections rail: the facet's top handles, titles from the rendered
    // menu, thumbnails from a second parallel request
    var rail = $('[data-sd-rail]');
    var colls = $('[data-sd-colls]');
    var content = $('[data-sd-content]');
    var facet = ((p && p.facet_counts) || []).filter(function (f) { return f.field_name === 'collections'; })[0];
    var top = railHandles((facet && facet.counts) || []);
    var tmap = titles();
    if (top.length) {
      $('[data-sd-colls-list]').innerHTML = top.map(function (c) {
        return '<a class="sd-ccard" href="/collections/' + esc(c.value) + '?q=' + encodeURIComponent(q) + '" data-sd-item data-sd-ccard="' + esc(c.value) + '">' +
          '<span class="sd-ccard__trio"><span></span><span></span><span></span></span>' +
          '<span class="sd-ccard__title">' + esc(tmap[c.value] || humanise(c.value)) + '</span>' +
          '<span class="sdialog__n">' + c.count + ' product' + (c.count === 1 ? '' : 's') + '</span></a>';
      }).join('');
      colls.hidden = false;
      thumbs(q, top.map(function (c) { return c.value; }));
    } else { $('[data-sd-colls-list]').innerHTML = ''; colls.hidden = true; }

    var ch = (byPlan.content && byPlan.content.hits) || [];
    if (ch.length) {
      $('[data-sd-content-list]').innerHTML = ch.map(function (h) { return row(h.document); }).join('');
      content.hidden = false;
    } else { $('[data-sd-content-list]').innerHTML = ''; content.hidden = true; }
    rail.hidden = colls.hidden && content.hidden;
  }

  function thumbs(q, handles) {
    var key = q + ' thumbs';
    var apply = function (res) {
      if (query !== q) return;   // the shopper has typed on
      var results = (res && res.results) || [];
      handles.forEach(function (h, i) {
        var card = $('[data-sd-ccard="' + h.replace(/"/g, '\\"') + '"]');
        var hits = (results[i] && results[i].hits) || [];
        if (!card || !hits.length) return;
        var slots = $$('.sd-ccard__trio span', card);
        hits.slice(0, 3).forEach(function (hit, k) {
          if (slots[k] && hit.document && hit.document.image) slots[k].innerHTML = '<img src="' + esc(sized(hit.document.image, 160)) + '" alt="" width="160" height="160" loading="lazy" decoding="async">';
        });
      });
    };
    if (cache[key]) { apply(cache[key]); return; }
    post({ searches: handles.map(function (h) {
      return { collection: C.collection || 'products', q: q, query_by: 'title,vendor,skus,product_type,tags', query_by_weights: '6,4,5,3,2',
        filter_by: 'collections:=' + JSON.stringify(h), per_page: 3, include_fields: 'id,handle,image', highlight_full_fields: 'none' };
    }) }, inflight).then(function (res) { remember(key, res); apply(res); }, function () { /* the trio stays blank, or the query moved on */ });
  }

  /* ---------- prefetch pipeline: every page, in batches of 50 -------------
   * Luke, 2026-09-17: "far more aggressively prefetch images and product data
   * in the infinite scroll ... batches of 50 ... continue until all possible
   * search results have been prefetched". paint() lays down page 1 (the
   * federated request); this then fetches page 2, 3, … sequentially with the
   * same query/sort/filters/fields, appends each batch of cards as it lands,
   * and warms each batch's images (the 460px rendition the card's <img> asks
   * for first, 6 at a time, in order) so the shopper scrolls into decoded
   * frames. A query change abandons the run (seq guard) — its late responses
   * are dropped; one failed page stops paging for that query; image warming
   * pauses while the dialog is closed and is skipped entirely under
   * navigator.connection.saveData. Pages are cached per query alongside page 1.
   * The sentinel ([data-sd-more]) is only the spinner now: the previous
   * scroll-driven pager is gone, the pipeline does its job unprompted. */
  var moreIn = $('[data-sd-more-in]');
  function spinning(on) { if (moreIn) moreIn.hidden = !on; }
  var run = { q: '', seq: 0 };
  var WARM_LANES = 6;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var warmQueue = [];
  var warming = 0;
  function warmNext() {
    if (saveData) { warmQueue.length = 0; return; }
    while (warming < WARM_LANES && warmQueue.length) {
      if (!open) return;                      // paused: show() calls warmNext again
      var u = warmQueue.shift();
      warming += 1;
      var img = new Image();
      var done = function () { warming -= 1; warmNext(); };
      img.onload = done; img.onerror = done;
      // the SAME srcset + sizes the card's <img> carries, so the browser's
      // candidate selection (viewport, DPR) picks the rendition the card will
      // ask for — warming a fixed 460px file warmed a URL the card never
      // requested at 1440/2x (it chose the 940w candidate) on the first preview
      img.sizes = window.STCard.GRID_SIZES;
      img.srcset = window.STCard.gridSrcset(u);
      img.src = window.STCard.cdn(u, 460);
    }
  }
  function warmBatch(hits) {
    if (saveData || !window.STCard) return;
    hits.forEach(function (h) { var d = h.document || h; if (d.image) warmQueue.push(d.image); });
    warmNext();
  }
  /* WHEN the run may start, and how it yields. MEASURED 2026-09-21
   * (perf/search-as-you-type, scripts/perf/typing-probe.mjs against production):
   * one settled query for "timberline vanity" on the home page fired 7 pages
   * of 50 back to back — 464KB of JSON in 500ms — and built 311 cards into a
   * dropdown that shows eight. At 4x CPU throttle (a laptop under load) the
   * same 17 keystrokes cost 5.6s of long-task main-thread time, ~330ms per
   * keystroke, all of it this run appending batches while the shopper was
   * still typing.
   *
   * The run itself STAYS — Luke, 2026-09-17: "far more aggressively prefetch
   * ... continue until all possible search results have been prefetched", and
   * that is what makes the dropdown's list scroll into decoded frames. What
   * changes is that it is no longer allowed to compete with the keyboard:
   *
   *   1. it does not start until the query has been quiet for SETTLE_MS, so a
   *      shopper mid-word pays for nothing (the seq guard already abandoned
   *      those runs — it just abandoned them AFTER the bytes and the cards);
   *   2. each page is scheduled through requestIdleCallback, so a batch of 50
   *      cards can never be parsed inside the frame that is painting a
   *      keystroke;
   *   3. its requests carry the query's AbortController, so typing on stops
   *      the pages arriving rather than dropping them on arrival;
   *   4. it pauses while the dialog is closed (image warming already did).
   *
   * None of this changes what is eventually prefetched, or the order, or the
   * markup. It changes only WHEN, and what happens when the shopper moves on.
   *
   * Full findings: docs/perf/2026-09-21-search-typing.md. Held by
   * scripts/search-typing-gate.mjs. */
  var SETTLE_MS = 400;
  var settleTimer = null;
  var idle = window.requestIdleCallback
    ? function (fn) { return window.requestIdleCallback(fn, { timeout: 500 }); }
    : function (fn) { return setTimeout(fn, 0); };

  function startPipeline(q, shown, found) {
    run = { q: q, seq: run.seq + 1, page: 1, shown: shown, found: found };
    warmQueue.length = 0;
    clearTimeout(settleTimer);
    spinning(shown < found);
    var page1 = cache[q] && cache[q].products && cache[q].products.hits;
    if (page1) warmBatch(page1);
    if (!(shown < found && live)) return;
    var r = run;
    settleTimer = setTimeout(function () {
      if (r.seq !== run.seq || query !== r.q) return;   // the shopper typed on while we waited
      nextPage(r);
    }, SETTLE_MS);
  }
  function nextPage(r) {
    if (r.seq !== run.seq || query !== r.q) return;
    if (!open) { run.paused = r; return; }             // resumed by show() via warmNext
    var page = r.page + 1;
    var key = r.q + ' p' + page;
    var go = function (res) {
      if (r.seq !== run.seq || query !== r.q) return;   // the shopper has typed on
      var rr = (res && res.results && res.results[0]) || {};
      var hits = rr.hits || [];
      var list = $('[data-sd-products-list]');
      if (hits.length) {
        var base = r.shown;
        list.insertAdjacentHTML('beforeend', hits.map(function (h, i) { return cardHTML(h.document, base + i + 1); }).join(''));
        warmBatch(hits);
      }
      r.page = page;
      r.shown += hits.length;
      r.found = rr.found != null ? rr.found : r.found;
      if (!hits.length || r.shown >= r.found) { spinning(false); return; }
      idle(function () { nextPage(r); });
    };
    if (cache[key]) { idle(function () { go(cache[key]); }); return; }
    var ctrl = inflight;
    var fetchPage = function (fallback) { return post({ searches: [productsSearch(r.q, fallback, page)] }, ctrl); };
    fetchPage(false).then(function (res) {
      var rr = res && res.results && res.results[0];
      if (rr && rr.error) return fetchPage(true);
      return res;
    }).then(function (res) {
      if (r.seq === run.seq) remember(key, res);
      idle(function () { go(res); });
    }, function (e) {
      if (aborted(e)) return;                      // superseded query: not a failure
      if (r.seq === run.seq) spinning(false);      // one failed page ends the run: no retry storm
    });
  }

  /* ---------- wiring ---------------------------------------------------- */
  // focus with the dialog mode active opens; typing re-renders (debounced)
  bar.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('input')) return;
    if (scope !== 'everywhere') return;
    // Escape: another keydown listener blurs the input before ours closes the
    // dialog, so our refocus arrives as a fresh focusin — measured on the
    // preview (focusout at +3ms, focusin at +5ms, dialog reopened at +13ms).
    // A focusin right after close() is that refocus, not the shopper coming
    // back to search.
    if (Date.now() - closedAt < 250) return;
    show();
  });
  // after Escape the caret stays in the input, so a click there fires no
  // focusin: the click itself reopens
  bar.addEventListener('click', function (e) {
    if (!e.target.matches || !e.target.matches('input')) return;
    if (scope !== 'everywhere' || open) return;
    if (Date.now() - closedAt < 250) return;
    show();
  });
  bar.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('input')) return;
    if (scope !== 'everywhere') return;
    if (!open) show();
    clearTimeout(timer);
    var v = inputValue();
    if (!v) { render(); return; }
    timer = setTimeout(render, DEBOUNCE);
  });
  // completions: put the query in the input and search it (the island's
  // input needs the native setter so InstantSearch hears it on grid pages)
  dialog.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sd-sug]');
    if (!b) return;
    e.preventDefault();
    var i = activeInput();
    if (!i) return;
    var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    setter.call(i, b.getAttribute('data-sd-sug'));
    i.dispatchEvent(new Event('input', { bubbles: true }));
    i.focus();
  });
  // clicking whitespace inside the dialog must not count as leaving it
  dialog.addEventListener('pointerdown', function () { pointerInside = true; });
  document.addEventListener('pointerup', function () { pointerInside = false; });
  // leaving the bar + dialog composite (Tab past the end, click elsewhere) closes
  document.addEventListener('focusin', function (e) {
    if (!open) return;
    if (bar.contains(e.target) || dialog.contains(e.target)) return;
    close(false);
  });
  document.addEventListener('pointerdown', function (e) {
    if (!open) return;
    if (bar.contains(e.target) || dialog.contains(e.target)) return;
    close(false);
  });
  // a hub tab or category taking the pointer closes the dialog (the panels
  // live under it; the shopper has moved on)
  var nav = header.querySelector('[data-hubnav]');
  if (nav) nav.addEventListener('pointerenter', function () { if (open && !pointerInside) close(false); });

  function items() {
    return $$('[data-sd-item], [data-sd-sug], .sdialog__cards .card__link:not([tabindex="-1"])').filter(function (el) {
      return el.offsetParent !== null && !el.closest('[hidden]');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (!open) return;
    var i = activeInput();
    var inInput = i && document.activeElement === i;
    var inDialog = dialog.contains(document.activeElement);
    if (e.key === 'Escape') {
      // usearch.js leaves Escape alone while .is-dialog-open is set, so the
      // first Escape closes the dialog and keeps the caret; the next blurs
      e.preventDefault();
      close(true);
      return;
    }
    if (!inInput && !inDialog) return;
    var list = items();
    if (!list.length) return;
    var idx = list.indexOf(document.activeElement);
    if (e.key === 'ArrowDown' || (e.key === 'ArrowRight' && inDialog)) {
      e.preventDefault();
      list[Math.min(list.length - 1, idx + 1)].focus();
    } else if (e.key === 'ArrowUp' || (e.key === 'ArrowLeft' && inDialog)) {
      e.preventDefault();
      if (idx <= 0) { if (i) i.focus(); } else list[idx - 1].focus();
    } else if (e.key === 'Home' && inDialog) { e.preventDefault(); list[0].focus(); }
    else if (e.key === 'End' && inDialog) { e.preventDefault(); list[list.length - 1].focus(); }
    else if (e.key === 'Enter' && inInput && scope === 'everywhere' && gridPage) {
      // the island swallows the form submit on grid pages; Everywhere means
      // the whole catalogue
      var v = inputValue();
      if (v) { e.preventDefault(); location.href = '/search?q=' + encodeURIComponent(v); }
    } else if (inDialog && e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
      // typing while a result is focused resumes in the input
      if (i) i.focus();
    }
  });
  // keep the dialog's height honest when the viewport changes
  window.addEventListener('resize', function () { if (open) place(); });
})();
